<template>
  <div class="card" :class="containerCss">
    <slot v-if="!is_header && !is_body && !is_footer"></slot>
    <div v-if="is_header" class="card-header">
      <slot name="header"> </slot>
    </div>
    <div v-if="is_body" class="card-body">
      <slot name="body"> </slot>
    </div>
    <div v-if="is_footer" class="card-footer">
      <slot name="footer"> </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "Card",
  props: {
    containerCss: { type: [String, Object, Array] },
    headerCss: { type: [String, Object, Array] },
    bodyCss: { type: [String, Object, Array] },
    footerCss: { type: [String, Object, Array] }
  },
  computed: {
    is_header() {
      return "header" in this.$slots;
    },
    is_body() {
      return "body" in this.$slots;
    },
    is_footer() {
      return "footer" in this.$slots;
    }
  }
};
</script>


<style lang="scss">
.card {
  border-radius: 0;
  background-color: var(--dp-c-card-background);
  color: inherit;
  width: 100%;
  &.content {
    box-shadow: 0px 0px 2px 0px rgba(255, 255, 255, 30%) inset;
  }
  &.is_loading {
    height: 100px;
  }
  box-shadow: var(--dp-c-card-shadow) inset;
  .card-header {
    border-bottom: 1px solid var(--dp-c-border-color);
    padding: 8px 10px;
    background-color: var(--dp-c-table-header-background);
  }
  .card-body {
    padding: 8px 10px;
    .btn {
      width: 85px !important;
      font-size: var(--fnt-12);
      &:not(:last-child) {
        margin-right: 12px;
      }
    }
  }
}

.overlay_loader .nb-spinner {
  width: 30px;
  height: 30px;
  margin-top: 25px;
}
</style>
